run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','reports'];

//funcion donde se definen la run

export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,reports) {
                MenuConstant[0]['menu'].push(reports);
}


// WEBPACK FOOTER //
// ./src/app/reports/reports.run.js